import SearchResults from './SearchResults';
export { SearchResults };
export default SearchResults;
